<template>
  <el-dialog
      v-el-drag-dialog
      append-to-body
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      title="打印工单箱标"
      class="materialCodeModal"
      width="400px"
      top="5vh">
    <div id="printMaterialBoxLabel">
      <el-form :inline="true" label-width="80px">
        <el-form-item label="订单编号">
          <el-input v-model="productInfo.billNo" readonly/>
        </el-form-item>
        <el-form-item label="订单数量">
          <el-input v-model="productInfo.quantity" readonly/>
        </el-form-item>
        <el-form-item label="箱标数量">
          <el-input v-model="boxNum"/>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer">
      <el-button @click="dialogVisible = false">关闭</el-button>
      <el-button type="primary" @click="print">打印</el-button>
    </span>
  </el-dialog>
</template>

<script>

  export default {
    data() {
      return {
        dialogVisible: false,
        productInfo: {},
        boxNum: 0,
      };
    },

    methods: {
      open(productInfo) {
        this.dialogVisible = true;
        this.productInfo = productInfo;
        this.boxNum = productInfo.quantity;
      },

      print() {
        this.printLoading = true;
        this.$http
          .postForFile("basic", "taskDispatchBills/printLabel/" + this.boxNum, this.productInfo)
          .then((res) => {
            let blob = new Blob([res.data], {type: "application/pdf"});
            let pdfUrl = window.URL.createObjectURL(blob);
            window.open(pdfUrl);
            this.printLoading = false;
            this.dialogVisible = true;
          }).catch(() => {
            this.printLoading = false;
            this.$message.error("获取打印信息失败");
          });
      },
    },
  };
</script>
<style lang="scss" scoped>
.materialCodeModal .el-dialog__header {
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 99999;
  box-sizing: border-box;
}

.materialCodeModal .el-dialog__footer {
  position: fixed;
  width: 100%;
  bottom: 0;
  z-index: 99999;
  box-sizing: border-box;
  background-color: #fff;
}

.materialCodeModal .el-dialog {
  margin: 2% auto !important;
  transform: scale3d(1, 1, 1);
  padding-top: 30px;
  padding-bottom: 39px;
  height: 90%;
}

.materialCodeModal .el-divider--horizontal {
  margin: 10px 0;
}

.materialCodeModal .el-dialog .el-dialog__body {
  height: 100%;
  background-color: #fff;
  overflow: scroll;
}
</style>

<style lang="scss" scoped>
#printMaterialBoxLabel {
  width: 76mm;
  height: 36mm;
  margin: 0 auto;
  margin-top: 1.5mm;
  page-break-before: always;
  font-size: 10px;

  table {
    width: 100%;
    height: 100%;

    td {
      border: 1px solid #111;
      border-bottom: 0;
      border-right: 0;
      padding: 1mm;
      box-sizing: border-box;
      height: 7mm;
    }

    tr:first-child td:first-child {
      border-bottom: 1px solid #111;
    }

    tr:last-child td {
      border-bottom: 1px solid #111;
    }

    tr td:last-child {
      border-right: 1px solid #111;
    }
  }
}
</style>
